import styled from 'styled-components';
import Button from '@mui/material/Button';

export const StyledButton = styled(Button)`
    background-color: transparent;
    color: #000000;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 500;
    text-transform: none;
    border-color: #cacaca;
    padding: 0px;
    z-index: 10;
    
    :hover {
        background-color: #f5f5f5;
        opacity: 0.8;
    }

    transition: background-color 0.2s;
`;
